module.exports = __webpack_public_path__ + "prod/1.42.2/img/h5_xtrh_three.7fde98f2.png";